<template>
	 <div
      class="card page mb-5 p-2"
      style="width: 1300px; margin: 0 auto; box-shadow: 10px 10px 5px #888888"
      id="v-content"
    >
      <p>
        <span
          class="float-right span_close"
          style="
            display: block;
            width: 20px;
            line-height: 20px;
            text-align: center;
            font-size: 25px;
          "
          @click="$router.go(-1)"
        >
          &times;
        </span>
      </p>
      <div style="margin: 0 auto; width: 1200px">
        <p style="margin: 20px 0 30px 0;">
          <span style="margin-right:50px;font-size:20px;">投诉信箱</span>
          <el-button type="primary" size="small" @click="DialogVisible = true">投诉反馈</el-button>
        </p>
      <el-table :data="tableData" border>
      	 <el-table-column
            prop="truename"
            label="投诉人"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="投诉人手机号"
            width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="decomplainanter"
            label="被投诉人"
            align="center"
            width="110"
          >
          </el-table-column>
          <el-table-column
            prop="jobs"
            label="岗位"
            width="160"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="jobs"
            label="状态"
            width="100"
            align="center"
          >
          <template slot-scope="scope">
          	<span :style="{color: scope.row.isopen == 0 ? 'green' : 'red'}">{{scope.row.isopen == 0 ? '未公开' : '已公开'}}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="contexts"
            label="投诉内容"
            align="center"
          >
          </el-table-column>
           <el-table-column
            prop="inserttime"
            label="投诉时间"
            align="center"
            width="150"
          >
          <template slot-scope="scope">
            <span>{{ scope.row.inserttime | TimeFormat }}</span>
          </template>
          </el-table-column>
      </el-table>

      <el-pagination
        style="margin: 20px 20px 20px 0;text-align:right;"
        background
        :page-size="20"
        layout="prev, pager, next"
        :total="total"
        @current-change = "changePage">
      </el-pagination>

      <el-dialog
        title="投诉反馈"
        :visible.sync="DialogVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="36%"
        center>
        <el-form ref="form" :model="form" label-width="160px">
          <el-form-item label="投诉人姓名" required>
            <el-input v-model.trim="form.truename" placeholder="请填写你的姓名"></el-input>
          </el-form-item>
          <el-form-item label="投诉人手机号" required>
            <el-input v-model.trim="form.phone" :maxlength="11" placeholder="请填写你的手机号"></el-input>
          </el-form-item>
          <el-form-item label="被投诉人姓名" required>
            <el-input v-model.trim="form.decomplainanter" placeholder="请填写被投诉人姓名"></el-input>
          </el-form-item>
          <el-form-item label="被投诉人岗位" required>
            <el-input v-model.trim="form.jobs" placeholder="请填写被投诉人职位"></el-input>
          </el-form-item>
           <el-form-item label="是否公开" required>
             <el-radio-group v-model="form.isopen">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
           <el-form-item :label="`投诉内容（${form.contexts.length} / 500)`" required>
            <el-input type="textarea" :rows="4" :maxlength="500" v-model.trim="form.contexts" placeholder="请输入投诉内容"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="DialogVisible = false">取 消</el-button>
          <el-button type="danger" :loading="isLoading" @click="submit">立即提交</el-button>
        </span>
      </el-dialog>
  </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				tableData: [],
        DialogVisible:false,
        form: {
          truename: "",
          phone: "",
          decomplainanter: "",
          jobs: "",
          isopen: 0,
          contexts: ""
        },
        isLoading: false,
        total: 0,
        pageIndex: 1
			}
		},
    filters: {
      TimeFormat(date) {
        if (!date) {
          return '';
        }
        let date1 = date.replace(/T/g, ' ')
        let time = date1.replace(/\.[\d]{0,3}/, '')
        return time
      }
    },
		methods: {
			getList() {
				this.$http.post("Dls/GetComplaintMailbox", {
          pageIndex: this.pageIndex
        }).then(res => {
					if (res.data.isok) {
						this.tableData = res.data.data
            this.total = res.data.recount
					}
				}).catch(err => {
					
				})
			},

      changePage(page) {
        this.pageIndex = page;
        this.getList()
      },

      submit() {
        if (!this.form.truename) {
          return this.$message.warning("投诉人姓名不可为空")
        }

        let reg = /^1[3,4,5,6,7,8,9]\d{9}/
        if (!reg.test(this.form.phone)) {
          return this.$message.warning("投诉人手机号输入错误")
        }

        if (!this.form.decomplainanter) {
          return this.$message.warning("被投诉人姓名不可为空")
        }

        if (!this.form.jobs) {
          return this.$message.warning("被投诉人岗位不可为空")
        }

        if (!this.form.contexts) {
          return this.$message.warning("投诉内容不可为空")
        }

        this.isLoading = true;
        this.$http.post("Dls/AddComplaintMailbox", this.form).then(res => {
          this.isLoading = false;
          if (res.data.isok) {
            this.DialogVisible = false;
            this.$message.success("投诉反馈成功")
            this.getList()
          } else {
            this.$message.error(res.data.message)
          }
        }).catch(err => {
          this.isLoading = false;
        })
      }
		},
		created() {
			this.getList()
		}
	}
</script>

<style></style>


// WEBPACK FOOTER //
// src/pages/complaint.vue